module.exports = __webpack_public_path__ + "static/about-img9-bcc10d9d050f1270d94eba8727cbeac6.jpg";